module.exports = __webpack_public_path__ + "img/resource-tech-image-66.fb07c623.jpg";